import formatUTCDate from '@/shared/tools/formatUTCDate'

// || '' is used to prevent sending 'null' as a string value

export const clientFormParametersGeneration = (customerData, id, country, action, gryvChecklistCheckedTitles) => {
  const options = new URLSearchParams()

  if (action !== '') {
    options.append('action_requested', action)
  }

  const {
    personal: {
      zohoId,
      civility = '-1',
      lastName = '',
      firstName = '',
      email = '',
      phone1 = '',
      phone2 = '',
      secondName,
      civility2 = '-1',
      lastName2 = '',
      firstName2 = '',
      birthdate = '',
    },
    preferences: { dataCollectionAuth, neverBounceResult, callbackTime, callbackDate, clientType, whatsappInteraction, createEkomiInteraction },
    professional: { socialReason, siret, activity, apeCode, taxId },
    additional: { comments = '', referral, referralFirstName = '', referralLastName = '' } = {},
  } = customerData

  options.append('id', id)
  options.append('zoho_id', zohoId)
  options.append('lang', country)

  // Preferences
  options.append('disclaimer', dataCollectionAuth ? '1' : '0')
  options.append('neverbounce_result', neverBounceResult)
  options.append('whatsapp_interaction', whatsappInteraction ? '1' : '0')
  if (createEkomiInteraction) {
    options.append('create_ekomi_interaction', '1')
  }

  if (callbackTime !== '' && callbackDate !== '') {
    const date = new Date(`${callbackDate} ${callbackTime}`).toISOString().slice(0, 19)
    options.append('web_callback', formatUTCDate(date) || '')
  }

  // Professional
  options.append('pro_social_reason', socialReason || '')
  options.append('pro_siret', siret || '')
  options.append('pro_activity', activity || '')
  options.append('pro_ape_code', apeCode || '')
  options.append('is_professional', clientType === 'pro' ? '1' : '0')

  // to be added in dataaase in the future
  options.append('pro_tax_id', taxId || '')

  // Personal data
  options.append('civility', civility || '')
  options.append('lastname', lastName || '')
  options.append('firstname', firstName || '')
  options.append('email', email || '')
  if (birthdate) options.append('birthday', birthdate || '')
  options.append('phone1', phone1 || '')
  options.append('phone2', phone2 || '')
  options.append('secondName', secondName === true ? '1' : '0')
  if (secondName) {
    options.append('civility2', civility2 || '')
    options.append('lastname2', lastName2 || '')
    options.append('firstname2', firstName2 || '')
  }

  // Additional data
  if (comments !== '') {
    options.append('subscription_comments', comments)
  }
  options.append('referral', referral === true ? '1' : '0')
  if (referral) {
    options.append('referral_firstname', referralFirstName || '')
    options.append('referral_lastname', referralLastName || '')
  }

  // Gryv checklist
  const allChecked = Object.values(gryvChecklistCheckedTitles).every(Boolean)
  if (allChecked) {
    options.append('log_gryv_completed_checklist', '1')
  }

  return options
}
